// @ts-ignore
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Typography,
  Grid,
  ListItemText,
  MenuItem,
  Button,
  Dialog,
} from '@material-ui/core';
import { MyPATExpansionPanel, MyPATSelect } from '../../../common';
import Link from '@material-ui/core/Link';
import Error from '@material-ui/icons/Error';
import contentService from '../../services/contentService';
import {
  Course,
  CourseType,
  QuestionBenchmarkItem,
  QuestionBenchmarks,
  QuestionBenchmarkError,
  AllQuestionBenchmarks,
} from '../../types/Benchmarks';
import { GoalLevel } from '../../../goal-management/types/GoalLevel';
import goalManagementService from '../../../goal-management/services/goalManagementService';
import { questionActions } from '../../reducers/questionCreateReducer';
import { validateQuestionBenchmarks } from '../../../../utils';
import CustomInfoIcon from '../../../common/CustomInfoIcon';
import { CONTENT_SECTION_KEYS, CONTENT_SPECIAL_PURPOSES, MODULES } from '../../../../constants/comman';
import SearchBarWithChips from '../../../course-Management/common/SearchBarWithChips';
import Select from "react-select";
import { SECTIONS } from '../../helper/contentValidation';
import AddFeedbackPopup from './AddFeedbackPopup';
const styles = (theme: Theme) =>
  createStyles({
    '.MuiDialog-paperWidthSm-419':{
      'max-width':'900px !important',
    },
    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },
    mt2x: {
      marginTop: '-26px',
    },
    dialogWidth: {
      width: 960,
      height: 'auto',
    },
    capitalizeText: {
      textTransform: 'capitalize',
    },
    cardHeading: {
      fontWeight: theme.typography.fontWeightRegular,
    },
    requiredHeading: {
      color: theme.palette.secondary.main,
    },
    hintBox: {
      marginTop: '24px',
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing.unit,
      '& textarea': {
        border: 0,
        padding: 0,
      },
      '& h6': {
        color: theme.palette.grey[400],
      },
      '& .suggested-box': {
        background: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing.unit,
        width: '100%',
        marginBottom: theme.spacing.unit,
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
    greyText: {
      color: '#999',
    },
    deleteButton: {
      display: 'flex',
      alignItems: 'flex-end',
      cursor: 'pointer',
      height: '100%',
      paddingBottom: 10,
    },

    dialogFooter: {
      marginTop: '38px',
      '& p': {
        fontSize: '20px',
      },
      '& p:nth-of-type(2)': {
        fontSize: '14px',
      },
    },
    dialogHeader: {
      marginTop: '38px',
      '& p': {
        fontSize: '20px',
      },
      '& p:nth-of-type(2)': {
        fontSize: '14px',
      },
    },
    divider_or: {
      width: '100%',
      position: 'relative',
      display: 'block',
      height: '25px',
      margin: '15px 0',
      '&::before': {
        content: "''",
        height: '1px',
        background: '#E4E4E4',
        position: 'absolute',
        left: 0,
        top: '14px',
        zIndex: 8,
        width: '100%',
      },
      '&::after': {
        content: "'OR'",
        height: '26px',
        width: '26px',
        background: '#E4E4E4',
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '27px',
        color: '#989898',
        position: 'absolute',
        left: '50%',
        marginLeft: '-13px',
        top: 0,
        zIndex: 9,
        textAlign: 'center',
        fontStyle: 'italic',
        borderRadius: '50%',
      },
    },
    displayFlexbox: {
      display: 'flex',
      justifyContent: 'flex-end',
      '& button': {
        marginTop: '24px',
      },
    },
    dialogHeightFix: {
      maxHeight: 'initial',
    },
    dialogPaper: {
      maxWidth: '960px',
      maxHeight: 'initial',
      padding: '20px',
      width: '100%',
    },
    errorText: {
      color: '#333',
      verticalAlign: 'middle',
      marginTop: '3px',
      fontSize: "12px !important",
      display: "flex",
      alignItems: "center",
      fontWeight: 400,
      '& svg': {
        verticalAlign: 'bottom',
        fontSize: "14px !important",
        marginRight: '5px',
        fill: '#1d7dea',
      },
    },
    benchTitle: {
      padding: '16px',
      // maxHeight: '290px',
      // overflow: 'auto',
    },
    customLink: {
      padding: 0,
    },
    // customSelect: {
    menuPaper: {
      maxHeight: 100,
    },
    // },
    okButton: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '19px',
      letterSpacing: '0.5px',
      color: '#FFFFFF',
      background: '#1D7DEA',
      padding: '4px 22px',
      width: 188,
      borderRadius: 4,
      '&:hover': {
        background: '#1D7DEA',
      },
    },
    headingTxt:{
      fontSize: 16,
      color: '#333',
      textAlign: 'center',
      marginBottom: 12,
      marginTop: 12,
    },
    subTxt:{
      '&>ul':{
        paddingLeft: 15,
        listStyle: 'none',
        '&>li':{
          fontSize: 14,
          color: '#333',
          textAlign: 'center',
          marginBottom: 9,
        }
      },
    },
    blankEntry: {
      '& :focus': {
        background: 'none',
      },
      outline: 'none'
    },
    optionalText: {
      fontSize: '20px',
      color: '#999999',
    },
    redColor: {
      color: '#F21D1D'
    },
    chipLabel:{
      fontSize:16,
      fontWeight:400,
      marginBottom: 10,
    },
    customReactSelect: {
      '& > div+div > div': {
        maxHeight: '150px'
      },
      '& .css-1okebmr-indicatorSeparator':{
        background: 'transparent',
      },
    },
    headingRelative: {
      position: 'relative',
    },
  });

interface AddBenchmarkingProps extends WithStyles<typeof styles> {
  subjects: any[];
  questionId?: string;
  allQuestionBenchmarks: AllQuestionBenchmarks;
  setQuestionBenchmarks: any;
  editQuestionBenchmarks: any;
  removeAllQuestionBenchmarks: any;
  setForceQuestionBenchmarkUpdate: any;
  addQuestionBenchmarkField: any;
  removeQuestionBenchmarkField: any;
  setQuestionBenchmarkErrors: any;
  resetQuestionBenchmarks: any;
  initialiseQuestionBenchmarks: any;
  relevantExams: any;
  isDisable: boolean;
  isBenchmarkingUpdated: boolean;
  defaultExpanded: boolean;
  questionSpecialPurposes: any;
  handleFormChange: Function;
  activeValidationFeedbackSection?: string;
  activeValidationFeedbackData?: number;
  handleAddCommentInFeedback?: Function;
  createNewValidationFeedback?: Function;
  ftreRelevantExam: any[],
  syllabusExams?: any;
  handleSaveBenchmarking?: Function;
}

interface GoalLevelsState {
  [courseId: string]: GoalLevel[];
}

const otherDialogProps = {
  fullWidth: true,
  maxWidth: 700,
  body: 'paper',
};

function AddBenchmarking(props: AddBenchmarkingProps) {
  const [courses, setCourses] = useState<Course[]>([]);
  const [goalLevels, setGoalLevels] = useState<GoalLevelsState>({});
  const [expanded, setExpanded] = useState(false);
  const [isDeletionCase, setIsdeletionCase] = useState(false);
  const previousRelevantExamsLength = useRef(0);
  const {
    subjects,
    classes,
    questionId,
    allQuestionBenchmarks,
    setQuestionBenchmarks,
    setForceQuestionBenchmarkUpdate,
    removeAllQuestionBenchmarks,
    removeQuestionBenchmarkField,
    editQuestionBenchmarks,
    addQuestionBenchmarkField,
    setQuestionBenchmarkErrors,
    resetQuestionBenchmarks,
    initialiseQuestionBenchmarks,
    relevantExams: allRelevantExam,
    defaultExpanded,
    questionSpecialPurposes,
    handleFormChange,
    activeValidationFeedbackSection,
    activeValidationFeedbackData,
    handleAddCommentInFeedback,
    createNewValidationFeedback,
    ftreRelevantExam = [],
    syllabusExams,
    handleSaveBenchmarking
  } = props;

  let benchmarks: QuestionBenchmarkItem[] = [];
  let errors: QuestionBenchmarkError[] = [];
  let forceBenchmarkUpdate = false;
  const relevantExams = syllabusExams  || ((ftreRelevantExam || []).length ? ftreRelevantExam : (allRelevantExam[questionId || ''] || []));

  const isFtre = questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE);

  const isAitsOrNationalLevel = questionSpecialPurposes.includes(CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST) || questionSpecialPurposes.includes(CONTENT_SECTION_KEYS.AITS);
  const isGlorifireOrFtre = !isAitsOrNationalLevel;


  if (questionId && allQuestionBenchmarks[questionId]) {
    benchmarks = allQuestionBenchmarks[questionId].benchmarks;
    errors = allQuestionBenchmarks[questionId].errors;
    forceBenchmarkUpdate = allQuestionBenchmarks[questionId].forceUpdate;
  }

  const conceptCodes = useMemo(() => {
    if (!subjects || subjects.length === 0) {
      return [];
    }
    // Reduce subjects to concept codes
    return subjects.reduce((finalCodes: string[], { subSubjects }: any) => {
      // Extract concept codes from sub subjects
      const conceptCodesFromSubSubjects = subSubjects.reduce(
        (codesFromSubSubject: string[], { chapters }: any) => {
          // Extract concept codes from chapters
          const conceptCodesFromChapters = chapters.reduce(
            (codesFromConcepts: string[], { concepts }: any) => {
              // Map over all the concepts and take conceptCode
              const codes = concepts.map(({ conceptCode }: any) => conceptCode);
              codesFromConcepts = codesFromConcepts.concat(codes);
              return codesFromConcepts;
            },
            []
          );
          codesFromSubSubject = codesFromSubSubject.concat(
            conceptCodesFromChapters
          );
          return codesFromSubSubject;
        },
        []
      );
      finalCodes = finalCodes.concat(conceptCodesFromSubSubjects);
      return finalCodes;
    }, []);
  }, [subjects]);

  useEffect(() => {
    if (questionId) {
      initialiseQuestionBenchmarks({ questionId });
    }
  }, [questionId]);

  useEffect(() => {
    return () => {
      // remove all benchmarks on unmounting
      if (questionId) {
        // resetQuestionBenchmarks({ questionId });
      }
    };
  }, [questionId]);

  useEffect(() => {
    if (questionId) {
      fetchBenchmarks({ questionId });
    }
  }, [questionId]);

  useEffect(() => {
    
    // if (conceptCodes && conceptCodes.length > 0) {
    //   fetchCourses(conceptCodes);
    // } else {
    //   if (!_.isEmpty(courses)) {
    //     setCourses([]);
    //   }
    //   if (!_.isEmpty(goalLevels)) {
    //     setGoalLevels({});
    //   }
    // }
    if (benchmarks.length > 0 &&
      (!!benchmarks[0].goalLevel.name || !!benchmarks[0].course.name) &&
      relevantExams.length < previousRelevantExamsLength.current && props.isBenchmarkingUpdated) {
      removeAllQuestionBenchmarks({ questionId });
      setIsdeletionCase(true);
    } else if (
      benchmarks.length > 0 &&
      (!!benchmarks[0].goalLevel.name || !!benchmarks[0].course.name) &&
      relevantExams.length < previousRelevantExamsLength.current
    ) {
      removeAllQuestionBenchmarks({ questionId });
      setForceQuestionBenchmarkUpdate({ questionId, data: true });
    }
    previousRelevantExamsLength.current = relevantExams.length;
    !isDeletionCase && relevantExams.forEach((exam: any) => {
      const courseTypeId = _.get(exam, 'id');
      courseTypeId && goalManagementService.getGoalLevels({
        courseTypeId
      }).then(res => {
        if (res.goalLevels) {
          setGoalLevels((prevGoalLevels: GoalLevelsState) => ({
            ...prevGoalLevels,
            [courseTypeId]: res.goalLevels,
          }));
          const isAdded = benchmarks.some(benchmark => {
            return benchmark.course.id === courseTypeId;
          })
          if(res.hasGoalLevels && !isAdded && isAitsOrNationalLevel) {
            handleAdditionOfBenchmarkRow();
          }
        }
      });
    });
  }, [questionId, relevantExams]);

  useEffect(() => {
    if (!isDeletionCase) return;
    let addedTillNow = benchmarks.length;
    relevantExams.forEach((exam: any) => {
      const courseTypeId = _.get(exam, 'id');
      courseTypeId && goalManagementService.getGoalLevels({
        courseTypeId
      }).then(res => {
        if (res.goalLevels) {
          setGoalLevels((prevGoalLevels: GoalLevelsState) => ({
            ...prevGoalLevels,
            [courseTypeId]: res.goalLevels,
          }));
          const isAdded = benchmarks.some(benchmark => {
            return benchmark.course.id === courseTypeId;
          })
          if (res.hasGoalLevels && !isAdded && addedTillNow < relevantExams.length && isAitsOrNationalLevel) {
            handleAdditionOfBenchmarkRow();
          }
          addedTillNow++;
        }
      });
    });
    setIsdeletionCase(false);
  }, [benchmarks])

  useEffect(() => {
    // Fetch goal levels for initially selected courses
    
    const initiallySelectedBenchmarks = benchmarks.filter(
      ({ isInitiallySelected }) => isInitiallySelected
    );
    
    initiallySelectedBenchmarks.forEach(({ course: { id: courseId } }) => {
      const foundCourse = courses.find(
        (course: Course) => course._id === courseId
      );
      if (foundCourse) {
        fetchGoalLevelsForCourse(foundCourse);
      }
    });
  }, [benchmarks, courses]);

  useEffect(() => {
    if (handleFormChange && benchmarks) {
      handleFormChange(benchmarks);
    }
  }, [benchmarks]);

  useEffect(() => {
    if (relevantExams && relevantExams.length && !questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE)) {
      benchmarks.forEach((item: any, index: number) => {
        if (item.course.name) {
          return;
        }
        const availableExam = relevantExams.find((course: CourseType) => !selectedCourseIdSet.has(course.id) && goalLevels[course.id] && goalLevels[course.id].length);
        let name = (availableExam || {}).name || '';
        let id = (availableExam || {}).id || '';
        if (name && id) {
          editQuestionBenchmarks({
            questionId,
            index,
            value: { id, name },
            fieldType: 'course',
          });
          fetchGoalLevelsForCourse({ id, name });
          handleSaveBenchmarking && handleSaveBenchmarking({
            questionId,
            index,
            value: { id, name },
            fieldType: MODULES.COURSE,
          });
        }
      });
    }
  }, [benchmarks, relevantExams]);

  useEffect(() => {
    benchmarks.forEach((benchmarkData: any) => {
      const courseTypeId = _.get(benchmarkData, 'course.id');
      courseTypeId && goalManagementService.getGoalLevels({
        courseTypeId
      }).then(res => {
        if (res.goalLevels) {
          setGoalLevels((prevGoalLevels: GoalLevelsState) => ({
            ...prevGoalLevels,
            [courseTypeId]: res.goalLevels,
          }));
        }
      });
    });
  }, [benchmarks]);

  const fetchBenchmarks = async ({ questionId }: { questionId: string }) => {
    const questionBenchmarks: QuestionBenchmarks = await contentService.getBenchmarks(
      { type: 'question', typeId: questionId }
    );

    if (!questionBenchmarks || !questionBenchmarks.hasBenchmarks) {
      return;
    }
    
    const selectedBenchmarks = questionBenchmarks.benchmarks.map(
      ({ goalLevel, course }) => {
        return {
          goalLevel,
          course,
          isDeleted: false,
          isInitiallySelected: true,
        };
      }
    );
    setQuestionBenchmarks({ questionId, data: selectedBenchmarks });
  };

  const fetchCourses = async (conceptCodes: string[]) => {
    try {
      const { courses } = await contentService.getCoursesByConceptCode({
        conceptCodes,
      });
      setCourses(courses);
      setGoalLevels({});
    } catch (error) {
      console.log(error);
    }
  };

  const fetchGoalLevelsForCourse = async (course: CourseType) => {
    const {
      // courseType: { id: courseTypeId },
      id: courseTypeId,
    } = course;
    
    try {
      // goals for the course was already fetched then no need to fetch it again
      if (goalLevels.hasOwnProperty(courseTypeId)) {
        
        return;
      }
      // Fixed api call on updating the benchmark
     /* const {  
        goalLevels: fetchedGoalLevels,
      } = await goalManagementService.getGoalLevels({
        // courseTypeId,
        courseTypeId
      });

      
      
      setGoalLevels((prevGoalLevels: GoalLevelsState) => ({
        ...prevGoalLevels,
        [courseTypeId]: fetchedGoalLevels,
      })); */
    } catch (error) {
      console.log(error);
    }
  };
  const handleCourseChange = (index: number, id: string) => {
    
    
    const value = relevantExams.find(({ id: courseId }: CourseType) => id === courseId);

      editQuestionBenchmarks({
        questionId,
        index,
        value: {
          id: value !== undefined ? value.id : '',
          name: value !== undefined ? value.name : '',
        },
        fieldType: 'course',
      });
      if(value !== undefined) {
        fetchGoalLevelsForCourse(value);
      }
    
  };

  const handleGoalLevelChange = (
    index: number,
    id: string,
    courseId: string
  ) => {
    let value = goalLevels[courseId].find(
      ({ _id: goalLevelId }: GoalLevel) => id === goalLevelId
    );
    editQuestionBenchmarks({
      questionId,
      index,
      value: {
        id: (value || {})._id || '',
        name: (value || {}).name || '',
      },
      fieldType: 'goalLevel',
    });
  };

  const handleDeletionOfBenchmarkRow = (index: number) => {
    removeQuestionBenchmarkField({ questionId, index });
  };

  const handleAdditionOfBenchmarkRow = () => {
    addQuestionBenchmarkField({ questionId });
  };

  const handleBenchmarkUpdate = () => {
    const { hasErrors, errors } = validateQuestionBenchmarks(benchmarks, {
      forceCourse: true,
    });
    if (!hasErrors) {
      setForceQuestionBenchmarkUpdate({ questionId, data: false });
    } else {
      setQuestionBenchmarkErrors({ questionId, data: errors });
    }
  };

  const handleRemoveAllBenchmarking = () => {
    setForceQuestionBenchmarkUpdate({ questionId, data: false });
    removeAllQuestionBenchmarks({ questionId });
    setExpanded(false);
  };

  const handleExpansion = () => {
    setExpanded((prevOpen: Boolean) => !prevOpen);
    const { hasErrors, errors } = validateQuestionBenchmarks(benchmarks);
    if (hasErrors) {
      setQuestionBenchmarkErrors({ questionId, data: errors });
    }
  };

  const hasErrorInAnyRow = useMemo(() => {
    return errors.reduce(
      (acc: Boolean, { course, goalLevel }) => acc || !!course || !!goalLevel,
      false
    );
  }, [errors]);

  function renderBenchmarkingPara() {
    return (
      <>
        <Grid>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid>
              <Typography className={classes.headingTxt}>
                Benchmarking should be done on the basis of following guidelines:
              </Typography>
            </Grid>
          </Grid>
          <Grid container direction="row" justify="center" className="">
            <Typography className={classes.subTxt}>
              <ul>
                <li>
                  Map the RPI or Potential rank range of the students who can solve this question for the respective Target Exam(s)
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  }

  function getBenchmarkHeadingError() {
    let hasError = false,
      errorMessage = '';
    if (!relevantExams.length && expanded) {
      hasError = true;
      errorMessage =
        'Relevant Exams need to be selected before adding benchmarking.';
    } else if (hasErrorInAnyRow) {
      hasError = true;
      errorMessage = 'Please select a ' + ( isFtre ? 'RPI/Potential' : 'goal level');
    }
    return { hasError, errorMessage };
  }

  const { hasError, errorMessage } = getBenchmarkHeadingError();

  // Set for all courseId of the courses which are visible
  const selectedCourseIdSet = useMemo(() => {
    const courseIdSet = new Set();
    
    benchmarks.forEach((benchmark) => {
      
      if(benchmark.course) {
        
        const { course: { id }, isDeleted } = benchmark;
        if (!isDeleted) {
          courseIdSet.add(id);
        }
      }
    });
    return courseIdSet;
  }, [benchmarks]);

  const showAddMoreButton =
    selectedCourseIdSet.size < relevantExams.filter(
      (course: CourseType) => {
        return !selectedCourseIdSet.has(course.id) && goalLevels[course.id] && goalLevels[course.id].length
      }
    ).length;

  return (
    <>
      <MyPATExpansionPanel
        defaultExpanded={defaultExpanded || false}
        // panelProps={{
        //   expanded,
        //   onChange: handleExpansion,
        // }}
        variant="white"
        hasExpandIcon
        customCollapseTitle={
          <Grid container justify="space-between">
            <Grid item>
            <Typography id='addBenchmarking' onClick={(event) => {event.stopPropagation();}} variant="h6" className={[classes.cardHeading, classes.headingRelative].join(' ')}>
              Add Benchmarking&nbsp;
              {!isGlorifireOrFtre ?
               <span className={classes.redColor}>*</span> 
                : <span className={classes.optionalText}> (Optional)</span>
              }
              <CustomInfoIcon
                // infoDialogContentType=""
                isInfoIcon={true}
                isRightArrow={false}
                isCenterArrow={true}
                knowMoreAbout={false}
                dialogTitle="Benchmarking"
                imageURL="\assets\svg\myLibrary\benchmarkInfo.svg"
                dialogPara=""
                details="Click to know more"
                toolTipDirection="top"
                showMore="false"
                htmlElement={renderBenchmarkingPara()}
              />
              {
                activeValidationFeedbackSection === SECTIONS.BENCHMARKING && (
                  <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} />
                )
              }
            </Typography>
            </Grid>

            <Grid item>
            {hasError && (
              <Typography
                className={classes.errorText}
                variant="caption"
                color="error"
              >
                {/* <Error /> */}
                <img src="/assets/svg/contentRequest/blueInfo.svg"/>&nbsp;
                {errorMessage}
              </Typography>
            )}
            </Grid>


          </Grid>
          // )
        }
        isDisable={props.isDisable}
      >
        {renderFields()}
      </MyPATExpansionPanel>
      {renderRemovedBenchmarkInfoPopup()}
      {forceBenchmarkUpdate && relevantExams.length > 0 && (
        <Dialog classes={{ paper: classes.dialogPaper }} open={true}>
          <Grid className={classes.dialogWidth}>{renderDialogContent()}</Grid>
        </Dialog>
      )}
    </>
  );

  function renderDialogContent() {
    return (
      <>
        <Grid className={classes.mt2x}>
          <Grid className={classes.dialogHeader}>
            <Typography
              variant="body1"
              classes={{ root: classes.capitalizeText }}
            >
              <strong>Update Benchmarking</strong>
            </Typography>
            <Typography variant="body1">
              Benchmarking needs to be updated as per updated relevant exams
            </Typography>
          </Grid>

          {/* <Grid className={classes.dialogContent}> */}
          {renderFields()}
          {/* </Grid> */}
          <Grid container justify="flex-end">
            {renderDialogActions()}
          </Grid>
        </Grid>
        <span className={classes.divider_or} />
        <Grid className={classes.dialogFooter}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography>
                <strong>Remove Benchmarking completely</strong>
              </Typography>
              <Typography>
                Benchmarking needs to be updated as per updated relevant exams
              </Typography>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleRemoveAllBenchmarking}
              >
                Remove Benchmarking
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }

  function renderRemovedBenchmarkInfoPopup() {
    const explicitlyShowDialog =
      forceBenchmarkUpdate && relevantExams.length === 0;
    if (!explicitlyShowDialog) {
      return null;
    }
    return (
      <CustomInfoIcon
        isInfoIcon={false}
        isCenterArrow={false}
        isRightArrow={false}
        knowMoreAbout={false}
        explicitlyShowDialog={explicitlyShowDialog}
        dialogCloseCallback={handleRemoveAllBenchmarking}
        dialogTitle="Benchmarking Removed"
        imageURL="/assets/svg/removedBenchmarkInfoIcon.svg"
        dialogPara="The existing benchmarking have been removed as relevant exams have been removed.Please update benchmarking again after adding the relevant exams."
      />
    );
  }

  function renderDialogActions() {
    const isUpdateDisabled = benchmarks && !benchmarks[0].course.name;
    return (
      <Grid container alignItems="center" justify="flex-end">
        <Grid item xs>
          <Grid className={classes.displayFlexbox}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleBenchmarkUpdate}
              disabled={isUpdateDisabled}
            >
              Update
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  function renderFields() {
    
    
    let courseId = '';
    let currentGoalLevels:any = [];
    const coursesToShow = relevantExams.filter(
      (course: CourseType) => {
        
        return !selectedCourseIdSet.has(course.id) && goalLevels[course.id] && goalLevels[course.id].length
      }
    );
    let targetExamList = coursesToShow.map(({ id, name }: CourseType) => {
      return (
        <MenuItem key={id} value={id}>
          <ListItemText primary={name} />
        </MenuItem>
      );
    })
    targetExamList.unshift(
      <li className={classes.blankEntry}>
        <MenuItem id={''} value={''}>
      <ListItemText primary='Select Target Exam' />
    </MenuItem>
    </li>
    )

    let ftreTargetExamList = coursesToShow.map(({ id, name }: CourseType) => {
      return {
        value: id,
        label: name,
        id,
      };
    })
    
    
    return (
      <div className={[classes.hintBox, classes.benchTitle].join(' ')}>
        {benchmarks.map(
          (
            {
              goalLevel,
              course,
              isInitiallySelected,
              isDeleted,
            }: QuestionBenchmarkItem,
            index: number
          ) => {
            if (isDeleted) {
              return null;
            }
            if(course) {
              courseId = course.id;
              currentGoalLevels = goalLevels[courseId] || [];
            }
            // const coursesToShow = props.relevantExams;
          
            const viewIndex = benchmarks
              .slice(0, index)
              .filter(({ isDeleted }) => !isDeleted).length; // no of benchmarks visible before this index
            const showDeleteButton = (viewIndex > 0 || isInitiallySelected || isFtre) && !isAitsOrNationalLevel;
            return (
              <Grid container spacing={24} key={index}>
                <Grid item xs={6}>
                  <Typography variant="body1" gutterBottom>
                    Target Exam
                  </Typography>
                { !questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE) ?
                  <MyPATSelect
                    isNative={false}
                    fullWidthControl
                    name="targetExam"
                    id="targetExam"
                    onChange={(e: any) =>
                      handleCourseChange(index, e.target.value)
                    }
                    value={course.name || ""}
                    error={!!errors[index] && !!errors[index].course}
                    errorText={errors[index] ? errors[index].course : ''}
                    // disabled={
                    //   // isInitiallySelected || 
                    //   relevantExams.length === 0}
                    displayEmpty
                    placeholder={
                      <Typography
                        variant="body2"
                        align="left"
                        inline
                        className={classes.greyText}
                      >
                        Select Target Exam
                      </Typography>
                    }
                  >
                    {targetExamList}
                  </MyPATSelect>
                  :
                  <Select
                    value={course.id ? {label: course.name || '', value: course.name || '', id: course.id || ''} : null}
                    onChange={(e:any)=>{handleCourseChange(index,e.value)}}
                    options={ftreTargetExamList}
                    placeholder={`Search Exam here`}
                    className={classes.customReactSelect}
                    blurInputOnSelect={true}
                  />
                }
                </Grid>

                <Grid item xs={5}>
                  <Typography variant="body1" gutterBottom>
                  { isFtre ? 'RPI/Potential' : 'Goal Level'}
                  </Typography>
                  <MyPATSelect
                    fullWidthControl
                    // className={classes.customSelect}
                    isNative={false}
                    name="goalLevel"
                    id="goalLevel"
                    value={goalLevel.name || ''}
                    error={!!errors[index] && !!errors[index].goalLevel}
                    errorText={errors[index] ? errors[index].goalLevel : ''}
                    onChange={(e: any) =>
                      handleGoalLevelChange(index, e.target.value, course.id)
                    }
                    displayEmpty
                    disabled={course ? !course.name : null}
                    placeholder={
                      <Typography
                        variant="body2"
                        align="left"
                        inline
                        className={classes.greyText}
                      >
                        Select { isFtre ? 'RPI/Potential' : 'Goal Level'}
                      </Typography>
                    }
                  >
                    {currentGoalLevels.length === 0 ? (
                      <MenuItem disabled value="">
                        <em>{ isFtre ? 'RPI/Potential' : 'Goal Level'} does not exist</em>
                      </MenuItem>
                    ) : null}
                    {currentGoalLevels.map(({ _id, name }: GoalLevel) => {
                      return (
                        <MenuItem key={_id} value={_id}>
                          <ListItemText primary={name} />
                        </MenuItem>
                      );
                    })}
                  </MyPATSelect>
                </Grid>
                <Grid item xs={1}>
                  {showDeleteButton && (
                    <div
                      className={classes.deleteButton}
                      onClick={() => handleDeletionOfBenchmarkRow(index)}
                    >
                      <img src="/assets/svg/delete.svg" alt="Delete" />
                    </div>
                  )}
                </Grid>
              </Grid>
            );
          }
        )}
        {showAddMoreButton && (
          <Grid container spacing={24}>
            <Grid item xs={6}>
              <Link
                className={classes.customLink}
                component="button"
                variant="body2"
                onClick={handleAdditionOfBenchmarkRow}
              >
                + Add More
              </Link>
            </Grid>
          </Grid>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    allQuestionBenchmarks: state.questionCreate.questionBenchmarks,
    relevantExams: state.questionCreate.selectedGoals,
    isBenchmarkingUpdated: state.conceptAddReducer.isBenchmarkingUpdated,
    questionSpecialPurposes: state.questionCreate.specialPurposes,
    ftreRelevantExam: state.questionCreate.ftreRelevantExam
  };
};

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      setQuestionBenchmarks: questionActions.setQuestionBenchmarks,
      removeAllQuestionBenchmarks: questionActions.removeAllQuestionBenchmarks,
      editQuestionBenchmarks: questionActions.editQuestionBenchmarks,
      setForceQuestionBenchmarkUpdate:
        questionActions.setForceQuestionBenchmarkUpdate,
      addQuestionBenchmarkField: questionActions.addQuestionBenchmarkField,
      removeQuestionBenchmarkField:
        questionActions.removeQuestionBenchmarkField,
      setQuestionBenchmarkErrors: questionActions.setQuestionBenchmarkErrors,
      resetQuestionBenchmarks: questionActions.resetQuestionBenchmarks,
      initialiseQuestionBenchmarks:
        questionActions.initialiseQuestionBenchmarks,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(React.memo(AddBenchmarking)));
